

export const mirandaBio = {
  _id: 'mirandaBioId',
  userId: 'mirandaUserId',
  email: 'miranda@email.com',
  aboutMe: [
    `Beginner kickboxer, brunch hobbiest, champion overthinker`,
    `Just your typical female professional with a short haircut who is therefore often mistaken for a lesbian`,
    `Swipe right if Ben & Jerry's and sweatpants sounds like an ideal Friday night`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who makes me laugh — no need for a provider, I've got that covered`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Reading The New Yorker in Central Park on Sundays with a cup of coffee from Zabars`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Should redheads wear orange?`,
    }
  ],
  hobbies: [
    `Baseball`,
    `Beer`,
    `Restaurants`,
    `The New Yorker`,
    `Melodrama`
  ],
  vitalInfo: {
    firstName: `Miranda`, 
    age: 33,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 68,
    heightCM: 172,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Philadelphia`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Harvard`,
    profession: `Partner`,
    employer: `Law Firm`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const carrieBio = {
  _id: 'carrieBioId',
  userId: 'carrieUserId',
  email: 'carrie@email.com',
  aboutMe: [
    `New Yorker into shoes, restaurants, and melodrama`,
    `The girl you locked eyes with at the cafe but never talked to`,
    `Sex columnist, looking for material for her next article`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who looks good in a suit`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Sundays in the park, going to a gallery and forgetting to look at the art, and when curtains match the bedsheets`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Stripes or plaid?`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Design`,
    `Restaurants`,
    `Coffee`,
    `Writing`
  ],
  vitalInfo: {
    firstName: `Carrie`, 
    age: 32,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 62,
    heightCM: 157,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Connecticut`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: `Brown University`,
    profession: `Sex Columnist`,
    employer: `The New York Star`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `Yes`,
    weed: `Sometimes`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const samanthaBio = {
  _id: 'samanthaBioId',
  userId: 'samanthaUserId',
  email: 'samantha@email.com',
  aboutMe: [
    `Smoking hot babe York searching for a firehose`,
    `Small town girl who gets a thrill from your skyscraper`,
    `Let's role play — You cough, I'll be the doctor`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `Someone who knows how to install a ceiling mirror`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Hotdogs, baguettes, cucumbers, salami, and lollipops`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Favorite partner-stretching exercise`,
    }
  ],
  hobbies: [
    `Fashion`,
    `Pilates`,
    `Cock-tales`,
    `Horsefront Riding`,
    `Being Fabulous`
  ],
  vitalInfo: {
    firstName: `Samantha`, 
    age: 43,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 68,
    heightCM: 172,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Florida`,
    languages: [`English`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Undergrad`,
    university: ``,
    profession: `Public Relations`,
    employer: `Samantha Jones PR`,
    children: `Don't have children`,
    familyPlans: `Don't want children`,
    datingIntentions: `Short-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Yes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Dog'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}

export const charlotteBio = {
  _id: 'charlotteBioId',
  userId: 'charlotteUserId',
  email: 'charlotte@email.com',
  aboutMe: [
    `Gallerist from Greenwich looking to top off her art collection with the family portrait that hangs over the fireplace`,
    `Park Avenue Princess, but don't worry you don't have to be Prince Charming — that's my dog's name`,
    `Gallerist with a roomful of charming prints and keeping an eye out for a Prince Charming`
  ],
  prompts: [
    {
      prompt: `I'm looking for`,
      response: `A house in the Hamptons, three well-dressed children, and a King Charles Spaniel`,
    },
    {
      prompt: `My simple pleasures`,
      response: `Running in Central Park, visual art, and linens`,
    },
    {
      prompt: `Let's debate this topic`,
      response: `Waspiest boy name`,
    }
  ],
  hobbies: [
    ``,
    ``,
    ``,
    ``,
    ``
  ],
  vitalInfo: {
    firstName: `Charlotte`, 
    age: 34,
    gender: `Female`,
    pronouns: 'Prefer not to say',
    sexuality: 'Straight',
    interestedIn: `Men`,
    interestedInAgeMin: 18,
    interestedInAgeMax: 99,
    heightInches: 64,
    heightCM: 163,
    inOrCmPreference: 'in',
    currentCity: `NYC`,
    hometown: `Connecticut`,
    languages: [`English`, `French`],
    religion: [`Prefer not to say`],
    politics: `Prefer not to say`,
    educationLevel: `Postgrad`,
    university: `Smith College`,
    profession: `Gallerist`,
    employer: `Art Gallery`,
    children: `Don't have children`,
    familyPlans: `Want children`,
    datingIntentions: `Long-term relationship`,
    relationshipType: `Prefer not to say`,
    ethnicity: `Prefer not to say`,
    alcohol: `Sometimes`,
    cigarettes: `No`,
    weed: `No`,
    drugs: `No`,
    pets: ['Prefer not to say'],
    zodiac: 'Prefer not to say',
    hidden: ['pronouns'],
  },
}